import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings';
import { ROUTES } from '../../../core/router/routes';
import { IUserPostRequest } from '../model/usersModel';
import * as Selectors from '../redux/usersSelectors';
import * as Actions from '../redux/usersActions';
import UsersForm from '../form/UsersForm';

const initialValues: IUserPostRequest = {
  username: '',
  roles: ['ROLE_ADMIN'],
};

const AdminsAdd: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const apiRequestState = useSelector(Selectors.apiUsersRequestState);
  const apiRequestError = useSelector(Selectors.apiUsersRequestError);
  const { show, hide } = useMainProgressContext();

  useEffect(() => {
    hide();
  }, []);

  return (
    <>
      <SnackbarSettings
        successMessage="users.admins.snackbar.add_success"
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiUsersRequestState}
        onSuccess={() => history.push(ROUTES.USERS.LIST)}
      />
      <UsersForm
        title="users.admins.add"
        initialValues={initialValues}
        onSubmit={(values: IUserPostRequest) => {
          show();
          dispatch(Actions.addUsers(values));
        }}
      />
    </>
  );
};

export default AdminsAdd;
